
import React from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

const DeleteConfirmation = ({ showModal,message,title,redeemStatus,buttonName, hideModal, handleRedeemVoucher, voucherdata }) => {
    return (
        <Modal
            isOpen={showModal}
            toggle={hideModal}
            size="lg"
            style={{ maxWidth: '50%' }}
        >
            <ModalHeader toggle={hideModal}><h3>{title}</h3></ModalHeader>
            <ModalBody><div className=""><h5>{message}</h5></div></ModalBody>
            <ModalFooter>
                <Button onClick={hideModal}>
                    Cancel
                </Button>
                {voucherdata !== undefined &&
                    <Button color="primary" onClick={() => { handleRedeemVoucher(voucherdata.voucherNumber, redeemStatus); hideModal(); }}>
                        {buttonName}
                    </Button>
                }
                {voucherdata === undefined &&
                    <Button color="primary" onClick={() => { handleRedeemVoucher(); hideModal(); }}>
                        {buttonName}
                    </Button>
                }
            </ModalFooter>
        </Modal >
    )
}
export default DeleteConfirmation;